import { configure } from '@/util/container';
import registerVTooltip from '@/util/v-tooltip';
import { VUE } from '..';

export default configure(async (get) => void registerVTooltip(await get(VUE)));
